module.exports = __webpack_public_path__ + "img/FONBET.KZ.8d649139.svg";